import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AddDiscountLayer from "../../components/ManageDiscount/DiscountFormPage";

const DiscountAdd = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Discount Management" link2="/discount" title="Add Discount" />

        <AddDiscountLayer />
      </MasterLayout>
    </>
  );
};

export default DiscountAdd;
